import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import PopuIABlock from "@/components/PopuIABlock";

export default function PopuIaPage() {
  return (
    <>
      <Header />
      <main className="max-w-3xl mx-auto px-4 py-6 md:py-10" data-testid="popu-ia-page">
        <Link to="/" className="inline-flex items-center gap-1 text-sm font-semibold accent-text hover:underline mb-4">
          <ChevronLeft size={14} /> Volver
        </Link>
        <div className="mb-6">
          <p className="overline accent-text mb-1">POPU.NEWS</p>
          <h1 className="font-headline uppercase text-3xl md:text-5xl leading-none">
            POPU <span className="accent-text">IA</span>
          </h1>
          <p className="text-sm mt-2" style={{ color: "var(--text-muted)" }}>
            Preguntá lo que quieras sobre tendencias, artistas o eventos. La IA te responde citando notas reales.
          </p>
        </div>
        <PopuIABlock />
      </main>
      <Footer />
    </>
  );
}
